var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIpLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3186_77982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0015C11.4846 32.0015 6.625 30.8278 6.625 28.2515C6.625 26.7821 8.24731 25.6194 11.1926 24.9785L11.5918 26.8114C9.07038 27.3598 8.5 28.1325 8.5 28.2515C8.5 28.7331 11.0791 30.1265 16 30.1265C20.9209 30.1265 23.5 28.7331 23.5 28.2515C23.5 28.1325 22.9296 27.3598 20.4083 26.8114L20.8074 24.9785C23.7527 25.6194 25.375 26.7821 25.375 28.2515C25.375 30.8278 20.5154 32.0015 16 32.0015Z",
    fill: "#FF7CF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2812 9.375H17.875V10.3125H19.2812C19.5394 10.3125 19.75 10.1019 19.75 9.84375C19.75 9.58556 19.5394 9.375 19.2812 9.375Z",
    fill: "#FF7CF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C10.3137 0 5.6875 4.62619 5.6875 10.3125C5.6875 12.6471 6.4895 14.935 7.94613 16.7533L16 26.9371L24.0539 16.7533C25.5105 14.935 26.3125 12.6471 26.3125 10.3125C26.3125 4.62619 21.6863 0 16 0ZM14.125 15H12.25V7.5H14.125V15ZM19.2812 12.1875H17.875V15H16V12.1875V11.25V7.5H19.2812C20.574 7.5 21.625 8.551 21.625 9.84375C21.625 11.1365 20.574 12.1875 19.2812 12.1875Z",
    fill: "#FF7CF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3186_77982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIpLocation);
export default __webpack_public_path__ + "static/media/icon_ip_location.be1865d7b87f2e19c3fa3e4723dfbbd5.svg";
export { ForwardRef as ReactComponent };